import { render, staticRenderFns } from "./NewInformation.vue?vue&type=template&id=d7170e2c"
import script from "./NewInformation.vue?vue&type=script&lang=js"
export * from "./NewInformation.vue?vue&type=script&lang=js"
import style0 from "./NewInformation.vue?vue&type=style&index=0&id=d7170e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports